import ConfirmationEventPaymentModal from "./ConfirmationEventPaymentModal";

export default ConfirmationEventPaymentModal;